import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-22757204"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "text-light-2",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    width: "16",
    height: "16"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("path", { d: "M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" }, null, -1));
const _hoisted_3 = [
    _hoisted_2
];
const _hoisted_4 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", {
        class: _normalizeClass(["fix-size inline-block flex items-center justify-center rounded-full overflow-hidden bg-gray-100", _ctx.sizeClasses])
    }, [
        (!_ctx.avatarUrl)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
            : (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: _ctx.avatarUrl,
                class: _normalizeClass(_ctx.sizeClasses)
            }, null, 10, _hoisted_4))
    ], 2));
}
